import { useState, useEffect, useLayoutEffect } from 'react'

interface WindowSize {
  width: number
  height: number
}

/**
 * A custom React hook that returns the current window width and height.
 * Automatically updates when the window is resized.
 */
export function useWindowSize(): WindowSize {
  const [size, setSize] = useState<WindowSize>(() => {
    if (typeof window === 'undefined') {
      return { width: 0, height: 0 }
    }

    return {
      width: window.innerWidth,
      height: window.innerHeight,
    }
  })

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return
    setSize({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }, [])

  useEffect(() => {
    // Skip execution during SSR (Next.js server components)
    if (typeof window === 'undefined') return

    // Handler to update the size state
    function handleResize() {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    // Initialize with the current window size
    // handleResize()

    // Add resize event listener
    window.addEventListener('resize', handleResize)

    // Cleanup listener on unmount
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return size
}